export default __webpack_public_path__ + "static/media/gallery_18.86ba625c.jpg";